<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
import draggable from 'vuedraggable'

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
}
export default {
  mixins: [navigation],
  name: 'app',
  components:{draggable},
  data() {
    return {
      last: "P_4",
      next: "P_6",
      topic: "Taller ¿Qué es crédito? / ¡Estoy listo para cursar esta lección!",
      dialog: false,
      resultado: 0,
      response: 'none',
      sent: false,
      show: false,
      reactivos: [{
          pregunta: 'Un auto nuevo',
          correcta: 'CRÉDITO AUTOMOTRIZ',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Liquidez para cubrir tus compromisos',
          correcta: 'CRÉDITO PERSONAL',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Construir tu patrimonio',
          correcta: 'CRÉDITO HIPOTECARIO',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Adquirir bienes y servicios cotidianamente',
          correcta: 'TARJETA DE CRÉDITO',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Pagar deudas muy altas',
          correcta: 'CRÉDITO HIPOTECARIO DE LIQUIDEZ',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        }
      ],
      respuestas: [
        "CRÉDITO AUTOMOTRIZ",
        "CRÉDITO PERSONAL",
        "CRÉDITO HIPOTECARIO",
        "TARJETA DE CRÉDITO",
        "CRÉDITO HIPOTECARIO DE LIQUIDEZ"
      ],
    }
  },
  methods: {
    grade: function(reactivos) {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correcta === reactivo.respuesta[0]) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('suspend_data', this.reactivos);
    },
    onScroll(){
      document.documentElement.style.overflow = 'hidden'
    },
    onScroll1(){
      document.documentElement.style.overflow = 'auto'
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.response != 'none',
        'btn-secondary': this.response == 'none'
      }
    }
  },
  beforeMount: function() {
    shuffle(this.respuestas);
  },
  beforeUpdate: function() {
    var respuestas = this.respuestas;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          respuestas.push(reactivo.respuesta.shift());
        } else {
          respuestas.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  created() {
    if ('suspend_data'in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.reactivos = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.response != 'none',
        'btn-secondary': this.response == 'none'
      }
    }
  }
}
</script>

<style>
  .caption{
    font-size: 9px !important;
  }
</style>

<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') Estás en: {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') ACTIVIDAD 
            v-card-text.titulo24Reg.text-center
              | La oferta de crédito es muy amplia y está diseñada para satisfacer necesidades de diversa naturaleza. Por ello es importante saber qué tipos de crédito existen y qué necesidades atienden.
            v-card-text.parrafoDestacadoB.text-center
              | Sigue tu intuición y asocia las necesidades de la columna izquierda con los correspondientes tipos de crédito de la columna derecha.
            v-layout(row, flex, align-center, align-content-center)
              v-flex.px-1(xs6, text-xs-center, align-content-center)
                v-card.py-0(flat, color='grey lighten-4 ', v-for='(reactivo, index) in reactivos ', :key='index ')
                  v-layout.my-2.text-xs-right(flat)
                    v-flex.py-0.my-0(xs11)
                      .blockquote.pregunta.text-xs-left(:class="{'caption': $vuetify.breakpoint.xs}")
                        | {{reactivo.pregunta}}
                    v-flex.py-3.mr-4.ml-0(xs1, text-xs-start)
                      v-icon(size='15px', v-if='sent && (reactivos[index].resultado==0) ', color='red ') fas fa-times
                      v-icon(size='15px', v-if='sent && (reactivos[index].resultado==1) ', color='green ') fas fa-check
              v-flex.px-1(xs3, text-xs-center)
                v-card.py-1(flat, v-for='(reactivo, index) in reactivos ', :key='index ')
                    draggable.selectorBox(v-model="reactivos[index].respuesta", group="people", tag='div')
                      .reactivo.text-center.text-uppercase.pt-3(v-for='reactivo in reactivos[index].respuesta ', :key='index ')
                        p(:class="{'caption': $vuetify.breakpoint.xs}") {{reactivo}}

              v-flex.px-1(xs3, text-xs-center)
                draggable(v-model="respuestas", group="people")
                  v-card.py-1(flat, style='cursor: pointer;', v-for='respuesta in respuestas ', :key='respuesta ')
                    .selectorBox
                      .reactivo.text-center.text-uppercase.pt-3(:class="{'caption': $vuetify.breakpoint.xs}") 
                        | {{respuesta}}
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled='respuestas.length!=0 ', @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Retroalimentación
                  v-dialog(v-model='dialog ', scrollable, persistent, max-width='930px ')
                    v-card.pa-0.ma-0
                      v-card-text.pa-0.ma-0(style='height: 600px;')
                        v-layout(row, justify-center)
                          v-flex(text-xs-center)
                            div(v-if='sent && (resultado==1) ')
                              v-layout(row, justify-center)
                                v-flex(text-xs-center)
                                  img.dialog_img(src='@/assets/ManoOk.png')
                              v-spacer.my-1.py-4
                              v-card-text.headline
                                | Excelente!
                            div(v-if='sent && (resultado!=1) ')
                              v-layout(row, justify-center)
                                v-flex(text-xs-center)
                                  img.dialog_img(src='@/assets/ManoStop.png')
                              v-spacer.my-1.py-4
                              v-card-text.headline
                                | Tuviste algunos errores...
                            v-card.questionCard.ma-0.pa-0(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5.my-0
                                  div(v-if='sent && (resultado==1)') Sabes muy bien para qué sirve cada tipo de Crédito. Aquí puedes ver la relación que hiciste de manera correcta.  
                                  div(v-if='sent && (resultado!=1)') Aquí puedes ver la relación correcta de los usos que tienen los distintos tipos de Crédito.    
                                p.text-sm-left.px-5.my-0
                                  b Necesitas un auto nuevo - Crédito Automotriz.
                                  |  Con este tipo de crédito puedes adquirir un auto nuevo, o incluso usado en el caso de algunas instituciones bancarias.
                                p.text-sm-left.px-5.my-0
                                  b Necesitas liquidez para cubrir tus compromisos - Crédito Personal.
                                  |  Un crédito personal puede sacarte de apuros en un evento repentino e inesperado.
                                p.text-sm-left.px-5.my-0
                                  b Necesitas construir tu patrimonio - Crédito Hipotecario.
                                  |  El crédito hipotecario es el instrumento ideal para comenzar a construir hoy tu patrimonio del mañana.
                                p.text-sm-left.px-5.my-0
                                  b Necesitas adquirir bienes y servicios cotidianamente - Tarjeta de Crédito.
                                  |  Las TDC son la mejor herramienta para financiarte bien sin pagar un peso de interés.
                                p.text-sm-left.px-5.my-0
                                  b Pagar deudas muy altas - Crédito hipotecario de liquidez.
                                  |  El crédito de liquidez con garantía hipotecaria puede ser una opción para pagar deudas.
                            v-btn.btn.dialog_btn(style='z-index:2 ', color='accent ', @click.prevent="nextPage(next)")
                              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>


